import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import { useFormikContext } from "formik";
import { map } from "lodash";
import { useCallback, useMemo, useRef } from "react";
import { CreateCampaignData } from "../../../types/campaign";
import { CAMPAIGN_VARIABLE } from "../../../utils/constants";

export function Sms() {
  const formik = useFormikContext<CreateCampaignData>();

  const inputMessageRef = useRef<HTMLInputElement>(null);

  const handleAddVariable = useCallback(
    (variable: string) => {
      const tempMessage = formik.values.message || "";
      const cursor = inputMessageRef.current.selectionStart;
      formik.setFieldValue(
        "message",
        `${tempMessage.substring(0, cursor)}${variable}${tempMessage.substring(
          cursor
        )}`
      );
    },
    [formik]
  );

  const labelInput = useMemo(() => {
    return `Texto - ${160 - formik.values.message?.length}`;
  }, [formik.values.message]);

  return (
    <Stack spacing={4}>
      <TextField
        autoFocus
        inputRef={inputMessageRef}
        rows={5}
        multiline
        label={labelInput}
        onChange={({ target: { value } }) => {
          if (value?.length <= 160) {
            formik.setFieldValue("message", value);
          }
        }}
        fullWidth
        size="small"
        value={formik.values.message}
        error={!!formik.errors.message}
        helperText={!!formik.errors.message && formik.errors.message}
      />
      <Stack justifyContent="center" direction="row" spacing={1}>
        {map(CAMPAIGN_VARIABLE, (variable) => (
          <Chip
            key={variable.value}
            color="primary"
            size="small"
            variant="filled"
            label={variable.name}
            onClick={() => {
              handleAddVariable(variable.value);
            }}
          />
        ))}
      </Stack>
    </Stack>
  );
}
